import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Icon as BlueIcon } from '@blueprintjs/core';
import { getTagFontColor, getUpdateFlagColor } from '@utils';

import { UpdateStatusPriority } from '@models/UpdateStatus.model';
import { format } from 'date-fns';

import { ITagRaw } from '@models/Tag.model';
import { HelpToolTipTextDiv } from '../../CreateUpdatesDialog.styles';

import {
  Container,
  Heading,
  Placeholder,
  PreviewRow,
  Text,
  PreviewDiv,
  HolderDiv,
  Internal,
  Tags,
  Row,
  PreviewText,
  TagCount,
  Icon,
} from './Preview.styles';

interface IPreview {
  priority: UpdateStatusPriority | null | 'new';
  subject?: string;
  affects?: number;
  firstTag?: ITagRaw;
  tagsCount?: number;
  date?: string | null;
}

const Preview = ({
  priority,
  subject,
  affects,
  date,
  firstTag,
  tagsCount,
}: IPreview) => {
  return (
    <Container>
      <PreviewDiv data-tip data-for="previewTooltip">
        <Heading>
          <Text>Priority</Text>
          <Text>Subject</Text>
          <Text>Affects</Text>
          <Text>Tags</Text>
          <Text>Date</Text>
          <Text className="from">From</Text>
        </Heading>
        <PreviewRow>
          {priority ? (
            <Icon>
              {priority === 'new' ? (
                <BlueIcon icon="record" color="#C1C4D6" />
              ) : (
                <BlueIcon icon="flag" color={getUpdateFlagColor(priority)} />
              )}
            </Icon>
          ) : (
            <Placeholder />
          )}
          <PreviewText limitOfLines={1}>
            {subject || <Placeholder />}
          </PreviewText>
          {affects ? (
            <HolderDiv>
              <BlueIcon icon="cube" color="#1371FE" size={12} />
              <Internal>{affects}</Internal>
            </HolderDiv>
          ) : (
            <Placeholder />
          )}
          {firstTag ? (
            <Row>
              <Tags
                background={firstTag.color}
                color={getTagFontColor(firstTag.color)}
              >
                {firstTag.name}
              </Tags>
              {!!tagsCount && <TagCount>{`+${tagsCount}`}</TagCount>}
            </Row>
          ) : (
            <Placeholder />
          )}
          {date ? (
            <PreviewText className="date" limitOfLines={1}>
              {format(new Date(date), 'MM/dd/yyyy')}
            </PreviewText>
          ) : (
            <Placeholder />
          )}
          <Internal>INTERNAL</Internal>
        </PreviewRow>
      </PreviewDiv>

      <ReactTooltip
        className="tooltip"
        id="previewTooltip"
        effect="solid"
        multiline
      >
        <HelpToolTipTextDiv>
          This is a summary of your update, as
          <br />
          you fill in information it will be updated
        </HelpToolTipTextDiv>
      </ReactTooltip>
    </Container>
  );
};

export { Preview };
